import { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import unescapedText from 'I18n/utils/unescapedText';
import { DrawerTypes, FileTypes } from 'file-manager-components/constants';
import ImageFieldBase from 'ContentComponents/cmv2/fields/ImageBase';
import FileBase from 'ContentComponents/cmv2/components/FileBase';
import withFileManager from 'ContentComponents/cmv2/decorators/withFileManager';
import PickersContext from 'ContentComponents/context/PickersContext';
import { fetchFile } from 'ContentData/api/Filemanager';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FileManagerWrappedImage = withFileManager(ImageFieldBase);
const FileManagerWrappedFile = withFileManager(FileBase);
const PickerTypes = {
  audio: 'audio',
  document: 'document',
  file: 'file',
  image: 'image',
  video: 'video'
};
class FileField extends Component {
  constructor(props) {
    super(props);
    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.handleVideoSelect = this.handleVideoSelect.bind(this);
    this.onClearFile = this.onClearFile.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this.state = {
      isVideoPickerOpen: false
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  handleFileSelect(response) {
    const {
      onFieldChange,
      returnType = 'url'
    } = this.props;
    const fileObject = response.toJS ? response.toJS() : response;
    if (returnType === 'url') {
      return onFieldChange(fileObject.default_hosting_url);
    }
    return onFieldChange(fileObject);
  }
  handleVideoSelect(response) {
    const {
      onFieldChange,
      returnType = 'url'
    } = this.props;
    const {
      sourceFileId
    } = response;
    this.setState({
      isVideoPickerOpen: false
    });
    fetchFile(sourceFileId).then(file => {
      if (returnType === 'url') {
        return onFieldChange(file.default_hosting_url);
      }
      return onFieldChange(file);
    }).catch(err => {
      throw err;
    });
  }
  onClearFile() {
    this.props.onFieldChange('');
  }
  onImageChange(value) {
    const src = value && value.src;
    this.props.onFieldChange(src);
  }
  render() {
    const {
      help_text: helpText,
      inline_help_text: inlineHelpText,
      picker = DrawerTypes.FILE,
      value = null,
      filteredExtensions,
      label,
      readOnly,
      required
    } = this.props;
    const browseText = picker === DrawerTypes.VIDEO.toLowerCase() ? unescapedText('ContentComponents.videoPicker.buttons.browseVideos') : undefined;
    let fileType;
    if (picker === DrawerTypes.DOCUMENT.toLowerCase()) {
      fileType = DrawerTypes.DOCUMENT;
    } else if (picker === DrawerTypes.VIDEO.toLowerCase()) {
      fileType = FileTypes.MOVIE;
    } else if (picker === DrawerTypes.AUDIO.toLowerCase()) {
      fileType = FileTypes.AUDIO;
    }
    if (picker === DrawerTypes.IMAGE.toLowerCase()) {
      return /*#__PURE__*/_jsx(FileManagerWrappedImage, Object.assign({}, this.props, {
        onFieldChange: this.onImageChange,
        picker: picker.toUpperCase(),
        resizable: false,
        showAlt: false,
        value: {
          src: value
        }
      }));
    }
    if (picker === DrawerTypes.VIDEO.toLowerCase()) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FileBase, {
          filteredExtensions: filteredExtensions,
          label: label,
          readOnly: readOnly,
          required: required,
          value: value,
          browseText: browseText,
          fileType: FileTypes.MOVIE,
          handleFileSelect: this.handleFileSelect,
          hasValue: !!value,
          helpText: helpText,
          inlineHelpText: inlineHelpText,
          onClearFile: this.onClearFile,
          onFileManagerOpen: () => {
            this.setState({
              isVideoPickerOpen: true
            });
          }
        }), this.state.isVideoPickerOpen && /*#__PURE__*/_jsx(PickersContext.Consumer, {
          children: ({
            HubSpotVideoPicker
          }) => {
            if (!HubSpotVideoPicker) {
              throw new Error('FileField requires HubSpotVideoPicker to be provided in PickersContext.');
            }
            return /*#__PURE__*/_jsx(HubSpotVideoPicker, {
              onClose: () => this.setState({
                isVideoPickerOpen: false
              }),
              onSelect: this.handleVideoSelect,
              showNonEmbeddable: true,
              allowNonHlsVideoEmbeds: true
            });
          }
        })]
      });
    }
    return /*#__PURE__*/_jsx(FileManagerWrappedFile, Object.assign({}, this.props, {
      browseText: browseText,
      fileType: fileType,
      handleFileSelect: this.handleFileSelect,
      hasValue: !!value,
      helpText: helpText,
      inlineHelpText: inlineHelpText,
      onClearFile: this.onClearFile,
      picker: picker.toUpperCase()
    }));
  }
}
export default FileField;